/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insufficientpermissionserror2Inputs */

const en_insufficientpermissionserror2 = /** @type {(inputs: Insufficientpermissionserror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You don't have the required permissions.`)
};

const de_insufficientpermissionserror2 = /** @type {(inputs: Insufficientpermissionserror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dafür hast du keine Berechtigung.`)
};

/**
* | output |
* | --- |
* | "You don't have the required permissions." |
*
* @param {Insufficientpermissionserror2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const insufficientpermissionserror2 = /** @type {((inputs?: Insufficientpermissionserror2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insufficientpermissionserror2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_insufficientpermissionserror2(inputs)
	return de_insufficientpermissionserror2(inputs)
});
export { insufficientpermissionserror2 as "insufficientPermissionsError" }